export default "__VITE_ASSET__Bof_0UNF__"